/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="67.93"
        height="95.58"
        viewBox="0 0 67.93 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M57.16 10.42a10.84 10.84 0 0 1 10.82 10.54v63.8a10.86 10.86 0 0 1-10.54 10.82H10.83A10.86 10.86 0 0 1 0 84.76a1.25 1.25 0 1 1 2.5 0 8.36 8.36 0 0 0 8.07 8.32h46.59a8.34 8.34 0 0 0 8.32-8.07V21.29a8.36 8.36 0 0 0-8.07-8.32h-8a1.252 1.252 0 0 1-.13-2.5h7.88Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M18.5 10.42a1.25 1.25 0 0 1 .13 2.49h-7.8a8.35 8.35 0 0 0-8.33 8.08v63.77a1.25 1.25 0 0 1-2.49.12V21.29A10.85 10.85 0 0 1 10.5 10.47Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M34.06 0a6.42 6.42 0 0 0-5.79 3.65 5.41 5.41 0 0 1-2.6 2.85 16.41 16.41 0 0 1-4.68 1.55c-.52.1-1 .16-1.41.21H18.5a1.24 1.24 0 0 0-1.22 1.25v6a1.26 1.26 0 0 0 1.22 1.27h30.91a1.25 1.25 0 0 0 1.25-1.25v-6a1.25 1.25 0 0 0-1.1-1.24h-.15a14.12 14.12 0 0 1-2.33-.28 16.15 16.15 0 0 1-4.58-1.48 5.53 5.53 0 0 1-2.53-2.57l-.13-.26A6.43 6.43 0 0 0 34.06 0Zm0 2.5a4 4 0 0 1 3.54 2.25 8.15 8.15 0 0 0 3.75 4 18.89 18.89 0 0 0 5.27 1.75l.33.06c.33.06.64.1.94.14h.27v3.59H19.77v-3.51a10 10 0 0 0 1.62-.23 18.89 18.89 0 0 0 5.39-1.79 7.8 7.8 0 0 0 3.7-4 3.94 3.94 0 0 1 3.58-2.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M32.71 22.7V25l-.36.07-.36.07a5.51 5.51 0 0 0-4.15 3.36 7 7 0 0 0-.48 3.14 5.39 5.39 0 0 0 2.89 4.59 21.62 21.62 0 0 0 2.41 1.06c1 .43 2 .82 3 1.24a1.85 1.85 0 0 1 1.15 2 2 2 0 0 1-1.62 2 5.37 5.37 0 0 1-1.27.13 3.18 3.18 0 0 1-3.25-2.36c-.09-.29-.16-.58-.24-.89l-3.86 1a8 8 0 0 0 1.93 3.85 6.49 6.49 0 0 0 4.22 2v3h2.44v-3c.5-.1 1-.18 1.47-.3a5.74 5.74 0 0 0 4-3.29 6.62 6.62 0 0 0 .47-4 5.27 5.27 0 0 0-2.64-3.85 28.8 28.8 0 0 0-3.69-1.61c-.75-.3-1.49-.65-2.22-1a1.65 1.65 0 0 1-.83-1 2.25 2.25 0 0 1 1.5-2.81h.08a2.6 2.6 0 0 1 2.58.67 4.65 4.65 0 0 1 1 1.59 4.23 4.23 0 0 1 .25.58l3.46-1.43a7.09 7.09 0 0 0-1.27-2.6 6.1 6.1 0 0 0-4.16-2.19v-2.3Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M56.33 55.42a1.25 1.25 0 0 1 .13 2.49h-36a1.252 1.252 0 0 1-.13-2.5h36ZM56.33 63.88a1.25 1.25 0 0 1 .13 2.49h-44.3a1.25 1.25 0 0 1-1.25-1.23 1.26 1.26 0 0 1 1.12-1.25h44.29ZM56.05 72.29a1.25 1.25 0 0 1 .13 2.49h-44.3a1.25 1.25 0 0 1-.13-2.49ZM56.05 80.75a1.271 1.271 0 0 1 .11 2.54h-44.3a1.25 1.25 0 0 1-.13-2.49Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ClipboardWithDollarSignPaperIcon';

export default Icon;
